import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const TotalRow = ({ providers, totalLabel, taxableReceiptsProviderValues }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn fontSize={16} isBold={true} padding={'0px 0px 10px 0px'}>
      {totalLabel}
    </DescriptionColumn>
    {providers.map((provider) => {
      const value = taxableReceiptsProviderValues.find((values) => values.providerID === provider.id)?.value || '';
      return (
        <ProviderColumn key={`taxableReceipts_${provider.id}`} isBold={true}>
          {value}
        </ProviderColumn>
      );
    })}
  </Row>
);
